import React, { useState, useEffect } from "react";
import axios from "axios";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { BASE_URL } from "./config";
import CreaEvento from "./CreaEvento";
import EventList from "./GestioneEventi";
import getCoordinates from "./geoUtils";

import { useParams } from 'react-router-dom';

const ProfilePageAdmnin = () => {
  const [azienda, setAzienda] = useState({
    idAzienda: useParams(),
    nomeAzienda: "",
    comune: "",
    indirizzo: "",
    descrizione: "",
    longitudine: "",
    latitudine: "",
    tipologie: "",
    partitaIva: "",
    iban: "",
    immagineProfilo: null, // Nuovo campo per l'immagine profilo
    galleria: [], // Array per la galleria di immagini
  });
  const { id } = useParams();
  const [selectedImage, setSelectedImage] = useState(null); // Per l'immagine selezionata
  const [isModalOpen, setIsModalOpen] = useState(false);     // Per gestire l'apertura della modal

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [galleria, setGalleria] = useState([]);
  const [profileImage, setProfileImage] = useState([]);
  const [loadingGalleria, setLoadingGalleria] = useState(false);
  const [errorGalleria, setErrorGalleria] = useState(null);
  

  // Definisci l'elenco dei comuni disponibili
  const comuniDisponibili = [
    { nome: 'Monopoli' },
    { nome: 'Alberobello' },
    { nome: 'Polignano a Mare' },
  ];

  // Caricare i dati dell'azienda dal server
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/azienda/user/` + id, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
          },
        });
        setAzienda(response.data);
      } catch (err) {
        setError("Errore nel recupero dei dati");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]); // Aggiunto 'id' come dipendenza per rieseguire l'effetto se l'id cambia

  // Funzione per gestire il cambio dei campi del form
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAzienda((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const openModal = (image) => {
    setSelectedImage(image); // Imposta l'immagine selezionata
    setIsModalOpen(true);     // Mostra la modal
  };

  const closeModal = () => {
    setSelectedImage(null);   // Rimuove l'immagine selezionata
    setIsModalOpen(false);   // Nasconde la modal
  };
  // Funzione per caricare immagine profilo
  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      axios
        .post(`${BASE_URL}/azienda/uploadProfileImage/` + id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
          },
        })
        .then((response) => {
          setAzienda((prev) => ({
            ...prev,
            immagineProfilo: response.data.url, // URL dell'immagine restituito dal server
          }));
        })
        .catch(() => setError("Errore durante il caricamento dell'immagine"));
    }
  };

  // Funzione per aggiungere immagini alla galleria
  const handleGalleryUpload = (e) => {
    const files = e.target.files;
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }

    axios
      .post(`${BASE_URL}/azienda/uploadGallery/` + id, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      })
      .then((response) => {

        setAzienda((prev) => ({
          ...prev,
          galleria: [...(prev.galleria || []), ...(response.data.urls || [])], // URL delle immagini restituite dal server
        }));
        caricaGalleria();
      })
      .catch(() => setError("Errore durante il caricamento della galleria"));
  };



  const caricaImmagineProfilo = async () => {

    try {
      const response = await axios.get(`${BASE_URL}/azienda/immagini/profile/` + id, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
      });
      setProfileImage(response.data); // Supponendo che l'API restituisca un array di URL
    } catch (error) {
      setErrorGalleria("Errore nel caricamento della galleria");
    } finally {
      setLoadingGalleria(false);
    }
  };


  const caricaGalleria = async () => {
    setLoadingGalleria(true);
    setErrorGalleria(null);
    try {
      const response = await axios.get(`${BASE_URL}/azienda/immagini/azienda/` + id, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
        },
      });
      setGalleria(response.data); // Supponendo che l'API restituisca un array di URL
    } catch (error) {
      setErrorGalleria("Errore nel caricamento della galleria");
    } finally {
      setLoadingGalleria(false);
    }
  };
  // Funzione per aggiornare i dettagli dell'azienda
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`${BASE_URL}/azienda/user/` + id, azienda, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      });
      alert("Dati aggiornati con successo!");
    } catch {
      setError("Errore durante l'invio dei dati");
    }
  };


  const handleDelete = async (idImmagine) => {
    // Logica per eliminare immagine dal server
    // Es. fetch DELETE al server
    console.log("Cancellata immagine con ID:", idImmagine);
    // Aggiornare lo stato locale

    try {
      await axios.delete(`${BASE_URL}/azienda/immagini/` + idImmagine, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
        },
      });
      caricaGalleria();
    } catch {
      setError("Errore durante l'invio dei dati");
    }


  };


  if (loading) return <div>Caricamento...</div>;
  if (error) return <div>{error}</div>;

  return (
    <Tabs onSelect={(index) => {
      if (index === 2) { // Carica la galleria quando si seleziona il tab Galleria
        caricaGalleria();
      }
      if (index === 1) { // Carica l'immagine profilo quando si seleziona il tab Immagine Profilo
        caricaImmagineProfilo();
      }
    }}>
      <TabList>
        <Tab>Dettagli Profilo</Tab>
        <Tab>Immagine Profilo</Tab>
        <Tab>Galleria</Tab>
        <Tab>Crea offerta</Tab>
        <Tab>Gestisci offerta</Tab>
      </TabList>

      {/* Tab Dettagli Profilo */}
      <TabPanel>
        <form onSubmit={handleSubmit}>
          <div>
            <label>Nome Azienda:</label>
            <input
              type="text"
              name="nomeAzienda"
              value={azienda.nomeAzienda}
              onChange={handleChange}
            />
          </div>
          <div>
            <label>Descrizione:</label>
            <input
              type="text"
              name="descrizione"
              value={azienda.descrizione}
              onChange={(e) => handleChange(e)}
            />
          </div>
          <div>
            <label>Comune:</label>
            <select
              name="comune"
              value={azienda.comune}
              onChange={handleChange}
            >
              <option value="">Seleziona un comune</option>
              {comuniDisponibili.map((comune) => (
                <option key={comune.nome} value={comune.nome}>{comune.nome}</option>
              ))}
            </select>
          </div>
          <div>
            <label>Indirizzo:</label>
            <input
              type="text"
              name="indirizzo"
              value={azienda.indirizzo}
              onChange={(e) => handleChange(e)}
            />
          </div>


          <div>
            <label>Partita IVA:</label>
            <input
              type="text"
              name="partitaIva"
              value={azienda.partitaIva}
              onChange={(e) => handleChange(e)}
            />
          </div>

          {azienda.tipologiaAzienda !== "Tradizioni" && (
            <div>
              <label>IBAN: </label>
              <input
                type="text"
                name="iban"
                value={azienda.iban}
                onChange={handleChange}
              />
            </div>
          )}
          <button type="submit">Salva</button>
        </form>
      </TabPanel>

      {/* Tab Immagine Profilo */}
      <TabPanel>
        <div>
          <label>Immagine Profilo:</label>
          <input type="file" accept="image/*" onChange={handleProfileImageChange} />
          {azienda.immagineProfilo && (
            <img
              src={profileImage}
              alt="Immagine Profilo"
              style={{ width: "150px", height: "150px", marginTop: "10px" }}
            />
          )}
        </div>

      </TabPanel>

      {/* Tab Galleria */}
      <TabPanel>
        <div>
          <label>Carica immagini per la galleria:</label>
          <input type="file" accept="image/*" multiple onChange={handleGalleryUpload} />
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5 , 1fr)",
            gap: "20px",
            marginTop: "20px",
          }}
        >
          {loadingGalleria ? (
            <p>Caricamento...</p>
          ) : errorGalleria ? (
            <p>{errorGalleria}</p>
          ) : (
            galleria.map((img, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <img
                  src={img.image}
                  alt={img.nomeFile}
                  style={{
                    width: "100%",
                    height: "auto",
                    maxWidth: "150px",
                    maxHeight: "150px",
                    cursor: "pointer",
                    marginBottom: "10px",
                  }}
                  onClick={() => openModal(img.image)}
                />
                <p style={{ margin: "5px 0", textAlign: "center", fontWeight: "bold" }}>
                  {img.nomeFile}
                </p>
                <button
                  style={{
                    backgroundColor: "#ff4d4f",
                    color: "white",
                    border: "none",
                    padding: "8px 12px",
                    cursor: "pointer",
                    borderRadius: "5px",
                    fontSize: "14px",
                  }}
                  onClick={() => handleDelete(img.idImmagine)}
                >
                  Cancella
                </button>
              </div>
            ))
          )}
        </div>

        {/* Modal */}
        {isModalOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
            onClick={closeModal}
          >
            <div
              style={{
                position: "relative",
                backgroundColor: "white",
                padding: "20px",
                borderRadius: "8px",
                maxWidth: "90%",
                maxHeight: "90%",
                overflow: "hidden",
              }}
            >
              <button
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  backgroundColor: "#ff4d4f",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  fontSize: "16px",
                  cursor: "pointer",
                }}
                onClick={closeModal}
              >
                ×
              </button>
              <img
                src={selectedImage}
                alt="Ingrandimento"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  display: "block",
                  margin: "0 auto",
                }}
              />
            </div>
          </div>
        )}
      </TabPanel>


      {/* Tab Crea Offerta */}
      <TabPanel>
        <div>
          <label>Crea offerta:</label>
          <CreaEvento idAzienda={azienda.idAzienda} />
        </div>

      </TabPanel>

      {/* Tab Gestisci Offerte */}
      <TabPanel>
        <div>
          <label>Gestisci offerte:</label>
          <EventList idAzienda={azienda.idAzienda} />
        </div>

      </TabPanel>
    </Tabs>
  );
};

export default ProfilePageAdmnin;